import { callWithMeta, createMeta, waitFor, type Meta } from '@/utils/store'
import { defineStore } from 'pinia'
import { useNetworkStore } from '../network/store'
import * as Api from './api'

type State = {
  softkeys: Api.AvailableSoftkey[]
  meta: Meta<{
    softkeys: undefined
    load: undefined
  }>
}

const getDefaultState = (): State => ({
  softkeys: [],
  meta: createMeta(['softkeys', 'load']),
})

export const useSoftkeysStore = defineStore('softkeys', {
  state: getDefaultState,

  actions: {
    RESET() {
      this.softkeys = getDefaultState().softkeys
      this.meta.softkeys = getDefaultState().meta.softkeys
    },

    async load(deviceId: number, { useCache = true } = {}) {
      const hasCached = ['pending', 'success'].includes(
        this.meta.softkeys.status
      )

      if (useCache && hasCached) {
        await waitFor(() => this.meta.softkeys.status !== 'pending')

        return
      }

      await callWithMeta({
        store: this,
        metaFields: { load: undefined, softkeys: undefined },
        apiCall: async () => await Api.loadSoftkeys(deviceId),
        onSuccess: ({ result, isLatest }) => {
          if (isLatest('softkeys')) {
            this.softkeys = result.payload
          }
        },
        onError: ({ result }) => {
          useNetworkStore().HANDLE_LOADING_ERROR(result.payload)
        },
      })
    },
  },
})
